import { Data } from "./ParticipationRow.interface";

export const useParticipationRow = (data: Data) => {
  const redirectTo = () => {
    const { redirectUrl  } = data;
    window.location.href = redirectUrl
  }

  return {
    redirectTo
  }
}
